<ng-select
  #autoComplete
  [items]="searchResults$ | async"
  [addTag]="false"
  [multiple]="false"
  [loading]="searchLoading"
  [typeahead]="searchInput$"
  [appendTo]="'body'"
  (clear)="clear()"
  [placeholder]="'settings.search-by-product-name-or-sku' | translate"
  (change)="selectResult($event)"
  [ngModel]="_value"
>
  <ng-template ng-label-tmp let-item="item" let-clear="clear">
    {{ item.name }}
  </ng-template>
  <ng-template ng-option-tmp let-item="item">
    <img [src]="item.featuredAsset | assetPreview : 32" />
    {{ item.name }}
  </ng-template>
</ng-select>
